<template>
    <v-row>
        <v-col
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    Aviso de Protesto Recebido
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-text-field
                            v-model="form.CNPJ"
                            v-mask="'##.###.###/####-##'"
                            outlined
                            label="CNPJ"
                            :rules="[$rules.required, $rules.cnpj]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.RAZAO_SOCIAL"
                            outlined
                            label="Razão Social"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="4"
                            >
                                <v-text-field
                                    v-model="form.NOTA_FISCAL"
                                    outlined
                                    label="Nota Fiscal"
                                    :rules="[$rules.required]"
                                    maxlength="10"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="4"
                            >
                                <v-text-field
                                    v-model="form.NOTA_FISCAL_SERIE"
                                    outlined
                                    label="Nota Fiscal - Série"
                                    maxlength="10"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="4"
                            >
                                <v-text-field
                                    v-model="form.PARCELA"
                                    outlined
                                    label="Parcela"
                                    maxlength="10"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.DATA_VENCIMENTO_ORIGINAL"
                                    v-mask="'##/##/####'"
                                    outlined
                                    label="Data de Vencimento Original"
                                    :rules="[$rules.required, $rules.brazilDate, $rules.brazilDatePast(fiveDaysAgo, 'O dia de vencimento deve ser ao menos 5 dias anterior ao dia atual')]"
                                    maxlength="10"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    ref="inputValor"
                                    v-model="form.VALOR"
                                    v-money="money"
                                    outlined
                                    label="Valor"
                                    prefix="R$"
                                    :rules="[$rules.required, validateMoney]"
                                    validate-on-blur
                                    maxlength="100"
                                />
                            </v-col>
                        </v-row>

                        <v-select
                            v-model="form.ID_MOTIVO_SOL_PROTESTO"
                            outlined
                            label="Motivo da Solicitação"
                            :items="motivosProtesto"
                            item-value="ID_MOTIVO_SOL_PROTESTO"
                            item-text="NOME"
                            :rules="[$rules.required]"
                        />

                        <v-text-field
                            v-model="form.CONTATO"
                            outlined
                            label="Contato"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.TELEFONE"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            outlined
                            label="Telefone"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.EMAIL"
                            outlined
                            label="E-mail"
                            type="email"
                            :rules="[$rules.required, $rules.email]"
                            maxlength="100"
                        />

                        <v-textarea
                            v-model="form.JUSTIFICATIVA"
                            outlined
                            label="Justificativa"
                            rows="3"
                            :rules="[$rules.required, $rules.min(15)]"
                            maxlength="500"
                            counter
                        />

                        <v-file-input
                            v-model="form.FILE_AVISO_CARTORIO"
                            outlined
                            label="Anexar aviso de cartório ou comprovante de pagamento"
                            prepend-icon="mdi-file-outline"
                            show-size
                            :accept="$root.config.FILE_ALLOWED_EXTENSIONS"
                            :rules="[$rules.required, $rules.fileSize($root.config.FILE_MAX_SIZE), $rules.fileExtension($root.config.FILE_ALLOWED_EXTENSIONS)]"
                        />

                        <v-layout justify-center>
                            <v-btn
                                color="primary"
                                type="submit"
                            >
                                Enviar Solicitação
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import { VMoney } from 'v-money';
    import { subDays } from 'date-fns';
    import api from '../../services/api';

    export default {
        directives: { money: VMoney },

        data() {
            return {
                form: {
                    CNPJ: null,
                    RAZAO_SOCIAL: null,
                    NOTA_FISCAL: null,
                    NOTA_FISCAL_SERIE: null,
                    PARCELA: null,
                    DATA_VENCIMENTO_ORIGINAL: null,
                    VALOR: null,
                    ID_MOTIVO_SOL_PROTESTO: null,
                    CONTATO: null,
                    TELEFONE: null,
                    EMAIL: null,
                    JUSTIFICATIVA: null,
                    FILE_AVISO_CARTORIO: null
                },

                motivosProtesto: [],

                money: {
                    precision: 2,
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    masked: false
                }
            };
        },

        computed: {
            fiveDaysAgo() {
                return subDays(new Date(), 5);
            }
        },

        async created() {
            try {
                const response = await api.getMotivosProtesto();

                this.motivosProtesto = response.data;
            } catch (error) {}
        },

        methods: {
            validateMoney(value) {
                if (value) {
                    return value !== '0,00' || 'Valor inválido';
                }

                return true;
            },

            async enviarSolicitacao() {
                try {
                    if (this.$refs.form.validate()) {
                        await api.saveSolProtesto(this.form);

                        this.$refs.form.reset();

                        this.$root.$emit('message', { text: 'Sua solicitação foi enviada com sucesso!', color: 'success' });
                    }
                } catch (error) {
                    let message = 'Erro ao salvar a solicitação.';

                    if (error.response && error.response.data && error.response.data.message) {
                        message = error.response.data.message;
                    }

                    this.$root.$emit('message', { text: message, color: 'error' });
                }
            }
        }
    };
</script>